import { useTheme } from "../../../app/providers/ThemeProvider";
import "./ThemeToggle.css";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? "Activar modo claro" : "Activar modo oscuro"}
      title={isDark ? "Modo claro" : "Modo oscuro"}
      className={[
        "theme-switch",
        isDark ? "theme-switch--dark" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={toggleTheme}
    >
      <span className="theme-switch__track">
        <span
          className="theme-switch__side-icon theme-switch__side-icon--sun"
          aria-hidden
        >
          <i className="ri-sun-line" />
        </span>
        <span
          className="theme-switch__side-icon theme-switch__side-icon--moon"
          aria-hidden
        >
          <i className="ri-moon-line" />
        </span>
        <span className="theme-switch__thumb">
          <span
            className={`theme-switch__thumb-icon ${
              isDark
                ? "theme-switch__thumb-icon--moon"
                : "theme-switch__thumb-icon--sun"
            }`}
          >
            <i className={isDark ? "ri-moon-line" : "ri-sun-line"} aria-hidden />
          </span>
        </span>
      </span>
    </button>
  );
}
